import React from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';

export default function PrivacyPolicy() {
  return (
    <Container className="my-5">
      <Row>
        <Col>
          <h1 className="text-center">Loading Privacy Policy...</h1>
          <p className="text-muted text-center">
            Last Updated: January 1, 2025
          </p>
          <hr />
        </Col>
      </Row>

    </Container>
  );
}